/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbarSearchAndPinList';
import themeConfig from '@/../themeConfig.js';
import colors from '@/../themeConfig.js';

import { MFA_TYPE } from '../constants';

const state = {
  // others
  otpKey: null,
  otpValue: null,
  isSidebarActive: false,
  breakpoint: null,
  sidebarWidth: 'default',
  reduceButton: themeConfig.sidebarCollapsed,
  bodyOverlay: false,
  sidebarItemsMin: false,
  theme: themeConfig.theme || 'light',
  navbarSearchAndPinList: navbarSearchAndPinList,
  sidebarUpdateCounter: 0,

  // to make sidebar react as soon as a new route is started, update this
  // else sidebar items don't detecte route change before it happened
  nextPath: '',

  activeUser: null,
  // activeUser: {
  //     id: 0,
  //     email: '',
  //     userToken: '',
  // },
  activeMerchant: null,
  themePrimaryColor: colors.primary,

  starredPages: navbarSearchAndPinList.data.filter(
    (page) => page.highlightAction
  ),
  userRole: null,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar component
  windowWidth: null,

  // Displayed in sidebar menu, if list not empty.
  accounts: [],
  // Format: account =
  // {
  //   name,
  //   settlementType,
  //   accountType,
  //   apiId,
  //   pubkey,
  //   localCurrency,
  // };
  selectedTransaction: null,
  isSignUp: false,
  // When a same row is clicked after already being selected,
  // we increment this number to trigger re-displaying of popup.
  popupDisplayCounter: 0,
  disableRefunds: false,
  selectedAddress: null,
  customInfo: null,
  merchants: [],
  resetPassword: false,
  timezone: '',

  searchResult: [],

  payoutList: [],
  fiatPayoutList: {
    data: [],
    pagination: {
      page: 1,
      perPage: 100,
      total: 0,
    },
  },
  fiatPayoutBalances: [],
  merchantBankAccountDetails: null,
  merchantProfileDetails: null,
  exchangeRate: [],

  merchantPayouts: [],
  merchantExchangeRate: {},

  //FOR ZEN Payout
  selectedPayout: null,
  payoutMetaData: null,
  fiatPayoutMetaData: null,

  //for dashboard subaccounts and permissions
  currentActiveEntityAdminData: {}, //entity admin refers to the dashboard users
  permissionGroup: [],
  entityAdminList: [],
  isAdmin: false,

  //for new display of local currency transaction
  localCurrencyTxn: {},
  localCurrencyTxnCounts: [],

  //for refunds page
  refundList: [],
  selectedRefund: null,
  refundMetaData: null,
  associatedPaymentDetails: null,

  //payout approval
  approvers: [],
  approvalTotal: 0,

  // for deposits
  deposits: [],
  depositMetaData: null,

  entityAdmin2FAType: MFA_TYPE.EMAIL

};

export default state;
